module.exports = __webpack_public_path__ + "m.no2.11b2c6d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/m.no2.jpg
// module id = htF6
// module chunks = 0